export class HidePrintRoomPropertiesMessage {}